import React, { useState, useContext } from 'react';
import Quotations from './Quotations';
import routes from "routes";

import { api_srv } from 'services';
import Loader from 'components/widgets/loader';
import { useQuery } from 'react-query';
import FiveHundred from 'pages/errors/500';
import { NavLink } from "react-router-dom";
import { Button } from 'antd';
import { ModalContext } from 'context/ModalContext';
import AddClientQuotation from 'components/widgets/modals/AddClientQuotation';
import { list_client_quotation } from 'services/apiSrv';

const ClientQuotationsContainer = (props) => {
    const [showAlert] = useState(false);

    async function fetch_all_quotations() {
        let resp = await (await api_srv).list_client_quotation();
        console.log('THE QUOTATIONS RESPONSE', resp);
        return resp.client_quotations;
    }

    const { isLoading, isSuccess, data, isError, refetch } = useQuery('quotations', list_client_quotation);
    console.log("cliet nqyutates", isLoading, isSuccess, data, isError)

    const handle_view_quotation = async (id) => {
        try {
            //  await view_quotation(id)
            props.history.push(`/dashboard/quotations/${id}`);
        } catch (err) {
            console.log(err);
        }

        props.history.push(`/dashboard/quotations/${id}`);
    };

    const add_asset = async (product_id, client_quotation_id) => {
        product_id = btoa(product_id);
        try {
            localStorage.setItem('client_quotation_id', client_quotation_id);
            props.history.push(`/dashboard/quotations/asset-details/${product_id}`);
        } catch (err) {
            console.log(err);
        }
    };

    const [search, setSearch] = useState('');
    const { setModalShow, modalShow, modalClose } = useContext(ModalContext);
   

    const searchSpace = (event) => {
        let keyword = event.target.value;
        setSearch(keyword);
    };

    return (
        <div>
            <AddClientQuotation refetch={refetch} show={modalShow} onHide={modalClose} />
           <Button
            className="btn-blue text-white rounded float-right mb-3"
            onClick={() => setModalShow(true)}
            >
            + Create
            </Button>
            {isLoading && <Loader />}
            {isError && <FiveHundred />}
            {isSuccess && (
            <Quotations
                data={Array.isArray(data?.draft_quotations) ? data.draft_quotations : []} // Fallback to empty array
                add_asset={add_asset}
                handle_view_quotation={handle_view_quotation}
                searchSpace={searchSpace}
                search={search}
                showAlert={showAlert}
            />
            )}
        </div>
    );
};

export default ClientQuotationsContainer;
